import React, { ReactNode } from "react";
import { usePageStyles } from "../styles/usePageStyles";

export interface BreadcrumbItem {
  label: string;
  href?: string;
  onClick?: () => void;
}

interface PageHeaderProps {
  breadcrumbs: BreadcrumbItem[];
  actions?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Page header component with breadcrumb navigation and action buttons
 */
export const PageHeader: React.FC<PageHeaderProps> = ({ 
  breadcrumbs, 
  actions,
  className,
  style 
}) => {
  const styles = usePageStyles();

  return (
    <div 
      style={{ ...styles.pageHeader, ...style }} 
      className={className}
    >
      <span style={styles.breadcrumb}>
        {breadcrumbs.map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && <span style={{ margin: '0 8px', opacity: 0.3 }}>/</span>}
            {item.href || item.onClick ? (
              <span 
                style={{ 
                  cursor: 'pointer',
                  color: index === breadcrumbs.length - 1 
                    ? styles.breadcrumbActive.color 
                    : styles.breadcrumb.color
                }}
                onClick={item.onClick}
              >
                {item.label}
              </span>
            ) : (
              <span 
                style={index === breadcrumbs.length - 1 ? styles.breadcrumbActive : {}}
              >
                {item.label}
              </span>
            )}
          </React.Fragment>
        ))}
      </span>
      {actions && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {actions}
        </div>
      )}
    </div>
  );
};
